import * as angular from "angular";
import {IController} from "angular";

export class SsoSilentRefreshViewComponent implements IController {

  constructor() {
  }

}

angular
  .module('bringoz.admin.commons')
  .component('ssoSilentRefreshView', {
    template: require('./sso-silent-refresh-view.html').default,
    controller: SsoSilentRefreshViewComponent
  });
